// @flow
import React, { useCallback } from 'react';
import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Tick from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';

const DeleteVirtualComponentVersionModal = ({
    virtualComponentVersion,
    onClose,
    pushFlag,
    deleteComponentVersionMutation,
    isDeleting,
    onComplete,
}) => {
    const deleteComponentVersion = useCallback(() => {
        deleteComponentVersionMutation({
            variables: { id: virtualComponentVersion.id },
        })
            .then((response) => {
                if (response?.data?.deleteVirtualComponentRelease?.success) {
                    onComplete?.();
                    pushFlag({
                        created: Date.now(),
                        icon: <Tick primaryColor="#00875A" />,
                        title: 'Component version deleted successfully.',
                        key: 'success',
                    });
                }
            })
            .catch(() => {
                pushFlag({
                    created: Date.now(),
                    icon: <ErrorIcon primaryColor="#DE350B" />,
                    title: 'An error occurred.',
                    description: 'Component version not deleted.',
                    key: 'error',
                });
            });
    }, [deleteComponentVersionMutation, onComplete, pushFlag, virtualComponentVersion.id]);

    return (
        <ModalTransition>
            <Modal key="delete-version-modal" appearance="warning" onClose={onClose}>
                <ModalHeader>
                    <ModalTitle>Delete {virtualComponentVersion.name}</ModalTitle>
                </ModalHeader>
                <ModalBody>Are you sure you want to delete this version?</ModalBody>
                <ModalFooter>
                    <Button appearance="warning" id="delete" onClick={deleteComponentVersion} isDisabled={isDeleting}>
                        Yes, delete
                    </Button>
                    <Button id="cancel" onClick={onClose} isDisabled={isDeleting}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </ModalTransition>
    );
};
export default DeleteVirtualComponentVersionModal;
